import { OrganizationRole } from 'src/api/main'

/**
 * The two tiers a member can be shown as assignable — everything except
 * `owner`, which is the account that created the workspace.
 *
 * Still used by the invite and join-request flows, whose payloads take a tier
 * rather than role ids. Assigning roles to an existing member goes through
 * `POST /organizations/access/{id}/roles/` with numeric ids instead
 * (see `UserRoleAssignForm`).
 */
export const MutableWorkspaceRole = {
  ADMIN: OrganizationRole.ADMIN,
  EMPLOYEE: OrganizationRole.EMPLOYEE
} as const

export type MutableWorkspaceRole =
  (typeof MutableWorkspaceRole)[keyof typeof MutableWorkspaceRole]

export function normalizeWorkspaceAccessRole(
  accessRole: string | undefined
): string | undefined {
  if (accessRole == null) {
    return undefined
  }
  const t = accessRole.trim()

  return t === '' ? undefined : t.toLowerCase()
}
